import React from 'react';

import BaseComponent from 'src/components/BaseComponent';

import { lang, remCss, withRouter } from 'src/helpers';

import model from './model';
import LANG_CONST from 'src/helpers/lang/const';
import { DatePickerField, MCButton, SearchTextField, View } from 'src/components/basic';
import AllStatsDoctors from './Doctors';
import AllStatsClinics from './Clinics';
import clinicsModel from './Clinics/model';
import doctorsModel from './Doctors/model';

class AllStats extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
    clinicsModel.subscribe(this.subscription);
    doctorsModel.subscribe(this.subscription);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
    clinicsModel.unsubscribe(this.subscription);
    doctorsModel.unsubscribe(this.subscription);
  }

  getActiveModel = () => {
    const tab = model.state.tab;
    return tab === 'clinics' ? clinicsModel : doctorsModel;
  };

  onSearchChange = (key, value) => {
    const model = this.getActiveModel();
    if (value?.toString() === model.input(key)?.toString()) return;
    model.setStateSilent({ [key]: value, pageIndex: 0 });
    model.setListStateSilent({ items: [], total: 0 }, model.getCurrentId());
    model.refresh();
  };

  onSearchTextChange = (text) => {
    const model = this.getActiveModel();
    model.setStateSilent({ search: text, pageIndex: 0 });
    model.handleChangeSearch(text);
    if (!text) {
      model.setListStateSilent({ items: [], total: 0 }, 'search');
      model.refresh();
    }
  };

  prevWeek = () => {
    const model = this.getActiveModel();
    console.log('prevWeek', model.id);
    let startDate = model.input('startDate').clone();
    let newStartDate = startDate.clone().startOf('isoWeek').subtract(1, 'week');
    let newEndDate = newStartDate.clone().add('1', 'week');
    model.setState({ startDate: newStartDate, endDate: newEndDate });
    model.refresh();
  };

  nextWeek = () => {
    const model = this.getActiveModel();
    console.log('nextWeek', model.id);
    let endDate = model.input('endDate').clone();
    let newStartDate = endDate.startOf('isoWeek');
    let newEndDate = newStartDate.clone().add(1, 'week');
    model.setState({ startDate: newStartDate, endDate: newEndDate });
    model.refresh();
  };

  render() {
    let searchQuery = this.getActiveModel().listInput('search');
    return (
      <div className={'mc-container-content mc-money-statistics'}>
        <div className={'mc-container-content__header'} style={{ gap: 15 }}>
          <span className={''}>{lang.t('All Stats')}</span>
          <View style={{ flex: 1, flexDirection: 'row', gap: 15 }}>
            <MCButton
              label={LANG_CONST.doctors}
              primary
              dark={model.state.tab === 'doctors'}
              light={model.state.tab !== 'doctors'}
              hover={model.state.tab !== 'doctors'}
              radius
              onClick={() => {
                model.setState({ tab: 'doctors' });
              }}
            />
            <MCButton
              label={LANG_CONST.clinics}
              primary
              radius
              dark={model.state.tab === 'clinics'}
              light={model.state.tab !== 'clinics'}
              hover={model.state.tab !== 'clinics'}
              onClick={() => {
                model.setState({ tab: 'clinics' });
              }}
            />
          </View>
          <div className={'mc-flex'}>
            <SearchTextField
              template={'2'}
              width={remCss(300)}
              placeholder={'Search'}
              onChange={this.onSearchTextChange}
              value={searchQuery}
            />
            <MCButton
              label={'<'}
              // small
              radius
              primary
              dark
              onClick={this.prevWeek}
            />
            <DatePickerField
              style={{ minWidth: remCss(150) }}
              template={6}
              icontype={2}
              close={false}
              noIcon={true}
              format='D MMM YYYY'
              placeholder={'Start Date'}
              placement={'bottom-center'}
              name={'startDate'}
              value={this.getActiveModel().input('startDate')}
              onChange={this.onSearchChange}
              invalid={{}}
            />
            <DatePickerField
              style={{ minWidth: remCss(150) }}
              template={6}
              icontype={2}
              close={false}
              noIcon={true}
              format='D MMM YYYY'
              placeholder={'End Date'}
              placement={'bottom-center'}
              name={'endDate'}
              value={this.getActiveModel().input('endDate')}
              onChange={this.onSearchChange}
              invalid={{}}
            />
            <MCButton
              label={'>'}
              // small
              radius
              primary
              dark
              onClick={this.nextWeek}
            />
          </div>
        </div>
        <div className={'mc-tab-box-opacity mc-grow'}>
          <div
            className={
              'mc-tab-content mc-flex-col ' +
              (model.input('tab') === 'doctors' ? '' : 'mc-inactive')
            }
          >
            <div className={'mc-flex-col mc-grow'}>
              <AllStatsDoctors />
            </div>
          </div>
          <div
            className={
              'mc-tab-content mc-flex-col ' +
              (model.input('tab') !== 'doctors' ? '' : 'mc-inactive')
            }
          >
            <div className={'mc-flex-col mc-grow'}>
              <AllStatsClinics />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(AllStats);
